import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import axios from 'axios';
import GestionesTable from "./componentes/gestionesTabla";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
/*import DataTable from "examples/Tables/DataTable";*/

import authorsTableData from "layouts/user-management/data";
import { useState,useEffect } from "react";
import MDButton from "components/MDButton";
import ModalGestiones from "./componentes/ModalGestiones";

const UserManagement = () => {
    const [open, setOpen] = useState(false);
    const [editGestion, setEditGestion] = useState(null);
    const [gestiones, setGestiones] = useState([]);
    const columns = [
    {
        Header: "Nombre",
        accessor: "nombre",
    },
    {
        Header: "Fecha Inicio",
        accessor: "fecha_inicio",
    },
    {
        Header: "Fecha Fin",
        accessor: "fecha_fin",
    },
    {
        Header: "Acciones",
        accessor: "acciones", // obligatorio aunque no exista en BD
        Cell: ({ row }) => (
        <>
            <MDButton
                size="small"
                color="primary"
                onClick={() => handleEdit(row.original)}
            >
                Editar
            </MDButton>

            <MDButton
                size="small"
                color="error"
                onClick={() => onDelete(row.original)}
            >
                Eliminar
            </MDButton>
        </>
        ),
    },
    ];

    const handleOpen = (gestion = null) => {
        setEditGestion(gestion);
        setOpen(true);
    };

    const fetchGestiones = async () => {
        try {
            const res = await axios.get('/gestiones');
            setGestiones(res.data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchGestiones();
    }, []);

    const handleClose = () => {
        setOpen(false);
        setEditGestion(null);
    };
    const handleEdit = (gestion) => {
        handleOpen(gestion); // abre tu modal con datos
    };
    const handleDelete = async (gestion) => {
    const confirm = window.confirm(`Eliminar gestión ${gestion.nombre}?`);

    if (!confirm) return;

    try {
        await axios.delete(`/gestiones/${gestion.id}`);
        fetchGestiones();
    } catch (error) {
        console.error(error);
    }
    };
    const handleSave = async (data) => {
        try {
            const formData = new FormData();

            formData.append('nombre', data.nombre);
            formData.append('fecha_inicio', data.fecha_inicio || '');
            formData.append('fecha_fin', data.fecha_fin || '');

            const handleEdit = (row) => {
            console.log("Editar:", row);
            setSelectedGestion(row);
            setOpenModal(true);
            };
            if (data.id) {
            // 🔥 EDITAR
            formData.append('_method', 'PUT');

            await axios.post(`/gestiones/${data.id}`, formData, {
                headers: {
                'Content-Type': 'multipart/form-data'
                }
            });

            } else {
            // 🔥 CREAR
            await axios.post('/gestiones', formData, {
                headers: {
                'Content-Type': 'multipart/form-data'
                }
            });
            }

            handleClose();
            fetchGestiones(); // recargar lista

        } catch (error) {
            console.error(error);
        }
    };

    return(
        <DashboardLayout>
            <DashboardNavbar/>
            <MDBox pt={6} pb={6}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                        <MDBox
                            mx={2}
                            mt={-3}
                            py={3}
                            px={2}
                            variant="gradient"
                            borderRadius="lg"
                            coloredShadow="info"
                            sx={{
                            background: "linear-gradient(45deg, #e60000, #ff3300)",
                            color: "white", // para que el texto se vea bien
                            }}
                        >
                            <MDTypography variant="h6" color="white">
                                Gestiones
                            </MDTypography>
                        </MDBox>
                        <MDBox p={2}>
                            <MDButton color="success" variant="contained" onClick={() => handleOpen()}>
                                Nueva Gestión
                            </MDButton>
                            <DataTable
                                table={{ columns, rows: gestiones }}
                                entriesPerPage={{ defaultValue: 10, entries: [5, 10, 15, 20] }}
                                canSearch={false}
                                showTotalEntries={true}
                                pagination={{ variant: "gradient", color: "info" }}
                                isSorted={true}
                                noEndBorder={false}
                            />
                        </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
            <ModalGestiones
                open={open}
                onClose={handleClose}
                onSave={handleSave}
                initialData={editGestion}
            />
        </DashboardLayout>
    );
};
export default UserManagement;